import React from 'react'
import AppSubmitModal from '../AppSubmitModal'
import animationSrc from './animation.mp4'

const AppSubmittedModal = ({ onCloseInitiated }) => (
  <AppSubmitModal
    title="The Highest of Fives!"
    animationSrc={animationSrc}
    description="Congrats on submitting your app to the Drift App Directory! It’s on its way to our lovely team of Drift engineers for review. We’ll let you know as soon as it’s done, and in the meantime, the highest of fives to you!"
    onCloseInitiated={onCloseInitiated}
  />
)

export default AppSubmittedModal
